import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { ADPResourceService, CustomFormControl } from "digital-core";
import { SnackbarService } from "src/app/core/services/snackbar/snackbar.service";
import { ValidateOtpResponseDtoV0 } from "../create-account.component";
import { AccountServiceV0 } from "../services/account.service";
import { GoogleAnalyticsService } from "src/app/core/services/google-tag-manager.service";
import { GTMOnboardingEvents, OnboardingSteps } from "src/app/model/google-tag-manager/api-status";

@Component({
  selector: 'app-verify-otp-v0',
  templateUrl: './verify-otp.component.html',
  styleUrls: ['./verify-otp.component.scss'],
})
export class VerifyOTPComponentV0 implements OnInit {
  @Input() email: string;
  @Input() encryptedEmail: string;
  @Input() maskedEmail: string;
  @Input() firstName: string;
  @Input() encryptedOTP: string;
  @Output() verifyOTPResponse = new EventEmitter<ValidateOtpResponseDtoV0>();
  @Output() resendOTPResponse = new EventEmitter();

  reminingAttempt;
  maxAttempt;
  resendCount = 0;
  otpError: string;
  otpControl = new CustomFormControl();
  timerDisplay: any;
  isTimerVisible: boolean = false;

  validateOtpForm = new UntypedFormGroup({
    otpControl: this.otpControl
  });

  constructor(
    private accountService: AccountServiceV0,
    private snackbarService: SnackbarService,
    private googleAnalyticsService: GoogleAnalyticsService,
    public router: Router,
    public resourceService: ADPResourceService
  ) {
  }

  ngOnInit() {

    this.maxAttempt = +this.resourceService.getPortalSetting("Signup_Create_Account_InvalidOTP_MaxAttempts").Value;
    this.reminingAttempt = this.maxAttempt;

    this.googleAnalyticsService.emitOnboardingEvent(GTMOnboardingEvents.InProcess, OnboardingSteps.VerifyOTP);
  }

  validateOtp(e) {
    this.accountService.validateOTP(this.encryptedOTP, this.otpControl.value, this.encryptedEmail).subscribe({
      next: (response) => {
        if (response?.isValidOTP ?? false) {
          this.googleAnalyticsService.contractId = response.contractId;
          this.googleAnalyticsService.isPrimary = true;
          this.googleAnalyticsService.emitOnboardingEvent(GTMOnboardingEvents.Complete, OnboardingSteps.VerifyOTP);
          this.otpError = undefined;
          this.verifyOTPResponse.emit(response);
          this.reminingAttempt = this.maxAttempt;
        }
      },
      error: (err) => {
        const emitError = {
          message: err?.error?.Message,
          type: err?.error?.ExceptionType,
          code: err?.error?.ErrorCode,
        }
        this.googleAnalyticsService.emitOnboardingEvent(GTMOnboardingEvents.Failed, OnboardingSteps.VerifyOTP, emitError);
        if (err.error && err.error.ErrorCode == 'OTPExpired') {
          this.otpError = this.resourceService.getViewLabel('Signup_Create_Account_OTPExpired_Error');
        } else if (err.error && err.error.ErrorCode == 'InvalidOTPCode') {
          this.reminingAttempt--;
          if (this.reminingAttempt > 0 && this.reminingAttempt < this.maxAttempt) {
            //this.otpError = `${this.resourceService.getViewLabel('Signup_Create_Account_InvalidOTP_Error')}, ${this.reminingAttempt} of ${this.maxAttempt} attempts remaining.`;
            this.otpError = this.resourceService.getViewLabel('Signup_Create_Account_InvalidOTP_Error').replace('{0}', String(this.reminingAttempt));
          } else {
            this.router.navigate(['/tech-support'], { queryParams: { headerKey: 'TechSupport_Signup_Create_Account_InvalidOTP' }});
          }
        } else if (err.error && err.error.ErrorCode == 'MaxRetryCountReached') {
          this.router.navigate(['/tech-support'], { queryParams: { headerKey: 'TechSupport_Signup_Create_Account_MaxRetryCountReached' }});
        } else {
          this.router.navigate(['/tech-support'], { queryParams: { headerKey: 'TechSupport_HavingTrouble' }});
        }
      }
    });
  }

  resendOTP() {
    if (this.resendCount === 3) {
      this.router.navigate(['/tech-support'], { queryParams: { headerKey: 'TechSupport_Signup_Create_Account_MaxResendEmailAttempts' }});
    } else {
      this.accountService.resendOTP(this.encryptedEmail, this.firstName, this.encryptedOTP).subscribe({
        next: (response: any) => {
          if (response?.encryptedOTP) {
            response['reqEmail'] = this.email;
            this.resendOTPResponse.emit(response);
            this.snackbarService.showSimpleMessage(`${this.resourceService.getViewLabel('Signup_Create_Account_VerifyOTP_Resend_Success')} ${this.maskedEmail}.`);
            this.otpError = undefined;
            this.validateOtpForm.reset();
            this.reminingAttempt = this.maxAttempt;
            if (this.resendCount < this.maxAttempt) {
              this.resendCount += 1;
              this.timer(1);
            }
          }
        },
        error: (err) => {
          const emitError = {
            message: err?.error?.Message,
            type: err?.error?.ExceptionType,
            code: err?.error?.ErrorCode,
          }
          this.googleAnalyticsService.emitOnboardingEvent(GTMOnboardingEvents.Failed, OnboardingSteps.VerifyOTP, emitError);
          if (err.error && err.error.ErrorCode == 'CreateOTP') {
            this.router.navigate(['/tech-support'], { queryParams: { headerKey: 'TechSupport_Signup_Create_Account_CreateOTP' }});
          } else if (err.error && err.error.ErrorCode == 'MaxRetryCountReached') {
            this.router.navigate(['/tech-support'], { queryParams: { headerKey: 'TechSupport_Signup_Create_Account_MaxRetryCountReached' }});
          } else {
            this.router.navigate(['/tech-support'], { queryParams: { headerKey: 'TechSupport_HavingTrouble' }});
          }
        }
      });
    }
  }

  timer(minute) {
    // let minute = 1;
    let seconds: number = minute * 30;
    let textSec: any = "0";
    let statSec: number = 30;

    const prefix = minute < 10 ? "0" : "";

    this.isTimerVisible = true;
    const timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.timerDisplay = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

      if (seconds == 0) {
        this.isTimerVisible = false;
        this.timerDisplay = undefined;
        clearInterval(timer);
      }
    }, 1000);
  }
}
